import { useEffect, useState } from 'react';
import { IonItem } from '@ionic/react';
import { Geolocation } from '@capacitor/geolocation';

import { present } from 'helpers/geolocation';
import makeCancelable from 'helpers/cancelable-promise';
import { withOnline } from 'components/helpers/online-helper';
import Map, {
  Marker, position, markerIconURL, US_CENTER
} from 'components/helpers/map';

function CoordinateSelection({location, onChange, online, readonly}) {
  const [userLocation, setUserLocation] = useState();
  const [userCenter, setUserCenter] = useState();
  const center = userCenter || (present(location) ? position(location) : userLocation || US_CENTER);

  useEffect(() => {
    if (!Geolocation) return;
    const geolocate = makeCancelable(Geolocation.getCurrentPosition());
    geolocate.promise.then(({coords}) => {
      if (!userCenter) setUserLocation({lat: coords.latitude, lng: coords.longitude});
    }).catch(_.noop);
    return geolocate.cancel;
  }, []);

  const setLocation = ({latLng}) => {
    if (readonly) return;
    if (present(location) && !userCenter) setUserCenter(center);
    onChange('latitude', _.round(latLng.lat(), 8));
    onChange('longitude', _.round(latLng.lng(), 8));
  };

  if (!online) {
    return (
      <IonItem color="danger">
        You must be online to view map.
      </IonItem>
    );
  }
  return (
    <Map
      center={center}
      mapContainerStyle={{maxHeight: "50vh", height: "400px"}}
      onClick={(present(location) || readonly) ? _.noop : setLocation}
      zoom={(present(location) || userLocation) ? 10 : 4}
    >
      {present(location) && (
        <Marker draggable={!readonly}
          position={position(location)}
          icon={markerIconURL(readonly ? 'PUBLIC' : 'OWN')}
          onDragEnd={setLocation}
        />
      )}
    </Map>
  );
}

export default withOnline(CoordinateSelection);
